import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JudetComponent } from './judet.component';
import { AddJudetComponent } from './add-judet/add-judet.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EditJudetComponent } from './edit-judet/edit-judet.component';

@NgModule({
  declarations: [JudetComponent, AddJudetComponent, EditJudetComponent],
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
  exports: [JudetComponent],
})
export class JudetModule {}
